import React from 'react'
import Button from './Button'
import Rate from './Rate'
import heroimg from '../img/branding-element.svg'

export default function Hero() {
  return (
    <section className='hero container'>
      <article className='hero-text'>
          <h1>The smartest way to build powerful <span>Web3 experiences</span></h1>
          <p>From blazing-fast websites to scalable web apps, we craft seamless digital solutions tailored to your business. Harness the latest technologies and a battle-tested workflow to bring your vision to life — faster, smarter, and better.</p>
          <footer className='hero-text-footer'>
            <div className='hero-button'>
              <Button cls='button-primary' />
            </div>
            <div className='hero-rate'>
              <Rate />
            </div>
          </footer>
      </article>
      <picture className='hero-img'>
          <img src={heroimg} alt='heroimg'/>
      </picture>
    </section>
  )
}
